window.addEventListener("load", function () {
    function getMainSwiper() {
        return $('.main-swiper')[0]?.swiper;
    }

    function isExternalLink(href) {
        return /^(https?:)?\/\//i.test(href || '');
    }

    function getSlideIndexByHash(hash) {
        if (!hash || hash.charAt(0) !== '#') return -1;
        let index = -1;
        // Chỉ tính slide CON TRỰC TIẾP của main swiper.
        // Dùng '.main-swiper .swiper-slide' sẽ đếm cả slide của swiper lồng
        // (vd 4 giải + 5 trang con trong #tournament) -> index lệch, slideTo nhảy sai frame.
        $('.main-swiper > .swiper-wrapper > .swiper-slide').each(function (i) {
            if ($(this).find(hash).length > 0) {
                index = i;
                return false;
            }
        });
        return index;
    }

    function getTargetIndexFromMenuLink($link) {
        const href = (($link.attr('href') || '') + '').trim();
        const dataIndex = $link.data('slideIndex') ?? $link.closest('li').data('slideIndex');

        if (Number.isInteger(dataIndex) && dataIndex >= 0) {
            return dataIndex;
        }

        if (href.charAt(0) === '#' && href.length > 1) {
            const indexByHash = getSlideIndexByHash(href);
            if (indexByHash >= 0) return indexByHash;
        }

        if (!href || href === '#') {
            const $internalLinks = $('#vxphl-ld-25-a-navigation .detail-menu ul li a').filter(function () {
                const menuHref = (($(this).attr('href') || '') + '').trim();
                return !isExternalLink(menuHref);
            });
            return $internalLinks.index($link);
        }

        return -1;
    }

    function syncMenuActiveBySlide(activeIndex) {
        const $items = $('#vxphl-ld-25-a-navigation .detail-menu ul li');
        $items.removeClass('active');

        $items.each(function () {
            const targetIndex = getTargetIndexFromMenuLink($(this).find('a'));
            if (targetIndex === activeIndex) {
                $(this).addClass('active');
                return false;
            }
        });
    }

    $('#vxphl-ld-25-a-navigation .logo').on('click', function (e) {
        e.preventDefault();

        const mainSwiper = getMainSwiper();
        if (!mainSwiper) return;
        mainSwiper.slideTo(0);

    });
    // $('#vxphl-ld-25-a-navigation .btn-dangkytruoc').remove();
    // $('#vxphl-ld-25-a-navigation .btn-dangkytruoc').on('click', function (e) {
    //     e.preventDefault();


    //     const mainSwiper = $('.main-swiper')[0].swiper;
    //     mainSwiper.slideTo(0);
    // });


    $('#vxphl-ld-25-a-navigation .detail-menu ul li a').on('click', function (e) {
        const $link = $(this);
        const href = ($link.attr('href') || '').trim();

        // If it's an external https link (and not a hash), allow default navigation
        if (isExternalLink(href) && href.charAt(0) !== '#') {
            return; // do not preventDefault -> follow link normally
        }

        e.preventDefault();

        const targetIndex = getTargetIndexFromMenuLink($link);
        const mainSwiper = getMainSwiper();
        if (mainSwiper && typeof mainSwiper.slideTo === 'function') {
            if (targetIndex >= 0) {
                mainSwiper.slideTo(targetIndex);
                syncMenuActiveBySlide(targetIndex);
            }
        }

        $('#vxphl-ld-25-a-navigation .detail-menu').removeClass('active');
    });

    const mainSwiper = getMainSwiper();
    if (mainSwiper && typeof mainSwiper.on === 'function') {
        syncMenuActiveBySlide(mainSwiper.activeIndex || 0);
        mainSwiper.on('slideChange', function () {
            syncMenuActiveBySlide(this.activeIndex || 0);
        });
    }
});

